import { InvestmentPurposeAndNature } from '../components';
import { useInvestmentPurposeAndNature } from '../hooks';
import { PageComponentProps } from '../types';

export const InvestmentPurposeAndNatureStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, onSubmit, submitLoading, goToBack } =
    useInvestmentPurposeAndNature();

  return (
    <InvestmentPurposeAndNature
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
